import React from 'react'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import add_contract_dialog from '../assets/add_contract_dialog.svg'
import add_forecast_dialog from '../assets/add_forecast_dialog.svg'
import close_dialog from '../assets/close_dialog.svg'
import AddContractForm from './AddContractForm';
import AddForecastForm from './AddForecastForm';
import Draggable from 'react-draggable';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function PopupAdd({openPopup, setOpenPopup, contract, setRefresh, setLoading, category, taskID, mainBudget}) {
  return (
    <Dialog 
    open={openPopup} 
    maxWidth="550px" 
    style={{borderRadius:'10px'}}
    PaperComponent={PaperComponent}
    aria-labelledby="draggable-dialog-title"
     >
    <DialogTitle 
    style={{ cursor: 'move' }}
    id="draggable-dialog-title"
     >
        <div style={{ display: 'flex' }}>
            <Typography variant="h6" component="div" style={{ flexGrow: 15 }}>
                <div>
                   {contract ? <>
                   <img src={add_contract_dialog} alt="add-contract-dialog" className='add-contract-dialog-icon'/>
                   <span className='add-contract-dialog-title'>
                    Add a new contract
                   </span>
                   </> : <>
                   <img src={add_forecast_dialog} alt="add-contract-dialog" className='add-contract-dialog-icon'/>
                   <span className='add-contract-dialog-title'>
                    Add a new forecast
                   </span>
                   </>} 
                </div>
             
            </Typography>
          <div style={{flexGrow: 1, textAlign:'right'}} >
          
          <IconButton  onClick={()=>setOpenPopup(false)}>
            <img src={close_dialog} alt="close-dialog" className='close-dialog-icon'/>
          </IconButton>
          </div>
        </div>
    </DialogTitle>
    <DialogContent >
        <div style={{width:'500px',marginTop:'30px'}}>
          {contract ? 
          <AddContractForm 
          setLoading={setLoading} 
          setRefresh={setRefresh} 
          setOpenPopup={setOpenPopup}
          category={category} 
          taskID={taskID}/> 
            : 
          <AddForecastForm 
          setLoading={setLoading} 
          setRefresh={setRefresh} 
          setOpenPopup={setOpenPopup}
          category={category} 
          taskID={taskID} 
          mainBudget={mainBudget}/>
            }
        </div>
    </DialogContent>
</Dialog>
  )
}

export default PopupAdd